import React, { ref, useRef, forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import {Modal} from 'react-bootstrap';
import { useSfb } from '../../../context/SfbContext';

import {Link} from 'react-router-dom';
import { IMAGES } from '../Dashboard/Content';

import profile from './../../../images/profile.svg';
import location from './../../../images/svg/location.svg';
import phone from './../../../images/svg/phone.svg';
import email from './../../../images/svg/email.svg';

import StudentReceipt from '../Student/StudentReceipt';
import ReactToPrint from 'react-to-print';
import { useReactToPrint } from 'react-to-print';  // For printing
import { useStudentsData } from '../../../context/StudentsContext';
import TuitionFeeReceipt from '../Adminer/TuitionFeeReceipt';


const PaymentActivitiesModal = forwardRef((props, ref) => {

    const componentRef = useRef();
    const reactToPrintRef = useRef();
    //loading state
    const [isLoading, setIsLoading] = useState(true);

    //load student data
    const { studentsData } = useStudentsData();

    const { sfb } = useSfb();
    const [modalBox, setModalBox] = useState(false);
    const [spaData, setSpaData] = useState(null); //spaData-> Student Payment Activities Data

    //useState to get selected pay_id
    const [pmtId, setPmtId] = useState(null);
    //set student  uid
    const [suid, setSuid] = useState(null);
    //selected student detail
    const [selectedDetail, setSelectedDetail] = useState(null);
    // base on the payID, set data for print 
    const [selectedData, setSelectedData] = useState(null);

    const handleCloseModal = () => {
        setSelectedData(null);
        setModalBox(false)
    };

    const getPayId = (pay_id, student_uid)=>{
        setPmtId(pay_id);
        setSuid(student_uid);
    }

    const clearData = () => {
        setPmtId(null);
        setSuid(null);
      };

      const handleAfterPrint = () => {
        setSelectedData(null);
        handleCloseModal(); // Close modal after print
        clearData(); // Clear data to prevent modal from reopening
      };
    // console.log(pmtId);
    const onAfterPrint = () => {
        setSelectedData(null);
        clearData();
      };
    
      // Print function using useReactToPrint with onAfterPrint
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: onAfterPrint,  // This will be called after the print dialog is closed
      });

    useEffect(() => {
        if (Array.isArray(spaData) && pmtId !== null && suid !== null) {
            const selectedBill = spaData.filter(bill => bill.pay_id === pmtId);
            const studentDetail = studentsData.filter(uid => uid.student_uid === suid);
            setSelectedData(selectedBill);
            setSelectedDetail(studentDetail);
        }
      }, [spaData, pmtId]);

      useEffect(() => {
        // You can define the condition here. For example, if you have a state variable that triggers printing.
        if (selectedData !== null) {
          // Simulating calling the print function
          reactToPrintRef.current.handlePrint();
        }
      }, [selectedData]);

    const [currentPage , setCurrentPage] = useState(1);  
    const recordsPage = 5;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;   

    let basicDetail = [];
    let records = [];
    let npage = 0;
    if(spaData !== null){
        basicDetail = [
            {title:'Parents', subtitle:spaData[0].s_parent, image:profile},
            {title:'Address', subtitle:spaData[0].r_address, image:location},
            {title:'Phone', subtitle:spaData[0].phone, image:phone},
            {title:'Email', subtitle:spaData[0].email, image:email},
        ];
        records = spaData.slice(firstIndex, lastIndex);
        npage = Math.ceil(spaData.length / recordsPage)
    }

    const number = [...Array(npage + 1).keys()].slice(1)


    // get fee structures 
    useImperativeHandle(ref, () => ({
        openModal(suid) {  
            const selectedSpaData = sfb.filter(uid => uid.suid === suid);
            setSpaData(selectedSpaData);
            setModalBox(true);      
        },  
    }));
    console.log(sfb);

    function prePage (){
        if(currentPage !== 1){
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage (id){
        setCurrentPage(id);
    }
    function nextPage (){
        if(currentPage !== npage){
            setCurrentPage(currentPage + 1)
        }
    }
    
    return(
        <>
            <Modal  onHide={setModalBox} size="xl" show={modalBox} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Payment History</h5>
                        <button type="button" className="btn-close"  onClick={()=>setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card h-auto">
                                        <div className="card-header p-0">
                                            <div className="user-bg w-100">
                                                <div className="user-svg">
                                                    <svg width="264" height="109" viewBox="0 0 264 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="0.0107422" y="0.6521" width="263.592" height="275.13" rx="20" fill="#FCC43E"/>
                                                    </svg>
                                                </div>
                                                <div className="user-svg-1">
                                                    <svg width="264" height="59" viewBox="0 0 264 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect y="0.564056" width="263.592" height="275.13" rx="20" fill="#FB7D5B"/>
                                                    </svg>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between">
                                                <div className="user">
                                                    <div className="user-media">
                                                        <img src={spaData !== null ?spaData[0].s_photo:IMAGES.avat9} alt="" className="avatar avatar-xxl" />
                                                    </div>
                                                    <div>
                                                        <h2 className="mb-0">{spaData !== null ?spaData[0].s_name:'No Name'}</h2>
                                                        <p className="text-primary font-w600">Student</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                {basicDetail.map((item, ind)=>(
                                                    <div className="col-xl-3 col-xxl-6 col-sm-6" key={ind}>
                                                        <ul className="student-details">
                                                            <li className="me-2">
                                                                <Link to={"#"} className="icon-box bg-secondary">
                                                                    <img src={item.image} alt="" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <span>{item.title}:</span>
                                                                <h5 className="mb-0">{item.subtitle}</h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ))}                            
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card h-auto">
                                        <div className="card-header border-0 p-3">
                                            <h4 className="heading mb-0">Payment History</h4>
                                        </div>
                                        <div className="card-body p-0">
                                            {/* ****Payment History table */}
                                            <div className="table-responsive basic-tbl">
                                                    <div id="example-payment_wrapper" className="dataTables_wrapper no-footer">
                                                        <table id="example-payment" className="display w-100 dataTable" >
                                                            <thead>
                                                                <tr>
                                                                    <th>Print</th>
                                                                    <th>Payment Number</th>
                                                                    <th>Date</th>
                                                                    <th>Amount</th>
                                                                    <th>Status</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {records.map((item, ind)=>(
                                                                    <tr key={ind}>
                                                                        <td>
                                                                            <div className="icon-box icon-box-sm bg-light me-2">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" 
                                                                                onClick={() => { // First, render the receipt
                                                                                    setTimeout(() => handlePrint(), 500); 
                                                                                    getPayId(item.pay_id, item.student_uid)}}>
                                                                                    <path d="M19 8H5c-1.1 0-2 .9-2 2v7h4v4h10v-4h4v-7c0-1.1-.9-2-2-2zm-4 11H9v-6h6v6zm3-9H6V7h12v3zm-2-7H8V2h8v2z" fill="green"/>
                                                                                </svg>                                                                        
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex align-items-center">	
                                                                                <div className="icon-box  icon-box-sm bg-danger">
                                                                                    <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M25.0004 1.33333C25.013 1.24043 25.013 1.14624 25.0004 1.05333C24.9888 0.975052 24.9664 0.898765 24.9337 0.826666C24.8985 0.761503 24.8584 0.699103 24.8137 0.64C24.763 0.555671 24.7001 0.479292 24.6271 0.413333L24.4671 0.32C24.3901 0.262609 24.3046 0.21762 24.2137 0.186666H23.9471C23.8658 0.107993 23.7709 0.0447434 23.6671 0H17.0004C16.6468 0 16.3076 0.140476 16.0576 0.390525C15.8075 0.640573 15.6671 0.979711 15.6671 1.33333C15.6671 1.68696 15.8075 2.02609 16.0576 2.27614C16.3076 2.52619 16.6468 2.66667 17.0004 2.66667H20.7737L15.4404 8.94667L9.68039 5.52C9.40757 5.35773 9.0858 5.29813 8.77296 5.3519C8.46011 5.40567 8.17671 5.56929 7.97373 5.81333L1.30706 13.8133C1.19479 13.9481 1.1102 14.1036 1.05815 14.2711C1.00609 14.4386 0.987577 14.6147 1.00368 14.7893C1.01978 14.9639 1.07017 15.1337 1.15198 15.2888C1.23378 15.4439 1.34538 15.5814 1.48039 15.6933C1.72028 15.8921 2.02219 16.0006 2.33373 16C2.52961 16.0003 2.72315 15.9575 2.9006 15.8745C3.07804 15.7915 3.23503 15.6705 3.36039 15.52L9.29373 8.4L14.9871 11.8133C15.2571 11.9735 15.575 12.0332 15.8848 11.982C16.1945 11.9308 16.4763 11.7719 16.6804 11.5333L22.3337 4.93333V8C22.3337 8.35362 22.4742 8.69276 22.7242 8.94281C22.9743 9.19286 23.3134 9.33333 23.6671 9.33333C24.0207 9.33333 24.3598 9.19286 24.6099 8.94281C24.8599 8.69276 25.0004 8.35362 25.0004 8V1.33333Z" fill="#FCFCFC"/>
                                                                                    </svg>
                                                                                </div>	
                                                                                <div className="ms-3">
                                                                                    <h6 className="mb-0 font-w600">#{item.pay_id}</h6>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <span>{item.app_date}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span className="doller font-w600"> ₹ {item.paid}</span>
                                                                        </td>
                                                                        <td className="pe-3">
                                                                            <span className={`font-w600 text-${item.pay_status === "Canceled" ? 'danger' : 'success'} `}>{item.pay_status}</span>
                                                                        </td>
                                                                    </tr>
                                                                ))}                                        
                                                            </tbody>
                                                        </table>
                                                        {spaData !== null
                                                            ? (<div className="d-sm-flex text-center justify-content-between align-items-center">                           
                                                            <div className='dataTables_info'>
                                                                Showing {lastIndex-recordsPage + 1} to{" "}
                                                                {spaData.length < lastIndex ? spaData.length : lastIndex}
                                                                {" "}of {spaData.length} entries
                                                            </div>
                                                            <div
                                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                                id="example-student_wrapper"
                                                            >
                                                                <Link
                                                                    className="paginate_button previous disabled"
                                                                    to="#"                                        
                                                                    onClick={prePage}
                                                                >
                                                                    <i className="fa-solid fa-angle-left" />
                                                                </Link>
                                                                <span>                                      
                                                                    {number.map((n , i )=>(
                                                                        <Link className={`paginate_button ${currentPage === n ? 'current' :  '' } `} key={i}                                            
                                                                            onClick={()=>changeCPage(n)}
                                                                        > 
                                                                            {n}                                                

                                                                        </Link>
                                                                    ))}
                                                                </span>
                                                                <Link
                                                                    className="paginate_button next"
                                                                    to="#"                                        
                                                                    onClick={nextPage}
                                                                >
                                                                    <i className="fa-solid fa-angle-right" />
                                                                </Link>
                                                            </div>
                                                        </div> )
                                                            :'No data'
                                                        }  
                                                    </div>
                                                </div>
                                            {/* ************table ends************ */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger light" onClick={()=>setModalBox(false)}>Close</button>
                    </div>
                </div>                
            </Modal>
            <ReactToPrint
                ref={reactToPrintRef}
                content={() => componentRef.current}
                onAfterPrint={handleAfterPrint} // Close modal after print
            />
            <div style={{ display: 'none' }}>
                {selectedData && selectedData[0] ? (
                    <TuitionFeeReceipt ref={componentRef} selectedData={selectedData[0]} />
                ) : (
                    <p>No data available to print</p>
                )}
            </div>
        </>
    )
})

export default PaymentActivitiesModal
